import React, { Suspense, lazy } from "react"
import { Navigate, Route, Routes, useLocation } from "react-router-dom"

import Loader from "shared/components/Loader/Global"

const TermsAndConditions = lazy(() =>
  import("../views/TermsAndConditions/TermsAndConditions")
)
const NewAccount = lazy(() => import("../views/NewAccount/NewAccount"))
const User = lazy(() => import("../views/User/User"))

export default function PlatformConnectRoutes(props) {
  const { isLoading } = props
  const location = useLocation()

  return isLoading ? (
    <Loader floating={false} />
  ) : (
    <Routes location={location}>
      <Route path="/" element={<Navigate to="start" />} />
      <Route
        path="start"
        element={
          <Suspense fallback={<Loader floating={false} />}>
            <NewAccount />
          </Suspense>
        }
      />
      <Route
        path="user"
        element={
          <Suspense fallback={<Loader floating={false} />}>
            <User />
          </Suspense>
        }
      />
      <Route
        path="terms-and-conditions/*"
        element={
          <Suspense fallback={<Loader floating={false} />}>
            <TermsAndConditions />
          </Suspense>
        }
      />
      <Route path="*" element={<Navigate to="/start" replace />} />
    </Routes>
  )
}
